import React from 'react';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { AppRoutes } from "navigations/app-routes";
import _ from "lodash";
import { stackProps } from "utils/helper-navigation";
import HelperString from "utils/helper-string";
import { createPageTitle } from 'utils/helper-page-title'
import ManagementTimeslotsScene from 'scenes/management/timeslots/index'
import ManagementTimeslotKindScene from 'scenes/management/timeslots/timeslot_kind/edit'
import ManagementTimeslotKindAddScene from 'scenes/management/timeslots/timeslot_kind/add'
import ManagementTimeslotKindExceptionEditScene from 'scenes/management/timeslots/timeslot_kind_exception/edit'
import ManagementTimeslotGroupScene from 'scenes/management/timeslots/timeslot_group/edit'

const Stack = createNativeStackNavigator();

const screens = {
	[AppRoutes.MANAGEMENT_TIMESLOTS]: {
		component: ManagementTimeslotsScene,
	},
	[AppRoutes.MANAGEMENT_TIMESLOT_KINDS]: {
		component: ManagementTimeslotKindScene
	},
	[AppRoutes.MANAGEMENT_TIMESLOT_KINDS_ADD]: {
		component: ManagementTimeslotKindAddScene
	},
	[AppRoutes.MANAGEMENT_TIMESLOT_KIND_EXCEPTION_EDIT]: {
		component: ManagementTimeslotKindExceptionEditScene
	},
	[AppRoutes.MANAGEMENT_TIMESLOT_GROUPS]: {
		component: ManagementTimeslotGroupScene
	}
}

const ManagementTimeslotsNavigator = ( props ) => {
	return (
		<Stack.Navigator
			initialRouteName={ AppRoutes.MANAGEMENT_TIMESLOTS }
			{ ...stackProps }>

			{ _.map( screens, ( screen, name ) => {
				return (
					<Stack.Screen
						key={ HelperString.hash( `ManagementTimeslotsNavigator`, name ) }
						name={ name }
						options={{
							title: createPageTitle( _.get( screen, 'title', null ) )
						}}
						component={ screen.component }
					/>
				);
			})}
		</Stack.Navigator>
	);
};

export default ManagementTimeslotsNavigator
